import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, token } = useAuth()

  if (!isAuthenticated || !token) {
    return <Navigate to="/connect" replace />
  }

  return <>{children}</>
}